export const filterVisibleOnly = (items: Array<any>) =>
  items.filter(item => !!item.isVisible);
